<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:headerTitle>
              <h4 class="card-title">{{ $t('info_manage.patient_report') }}</h4>
          </template>
          <template v-slot:body>
            <b-row>
                  <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                      <ValidationProvider name="Registration Year" vid="registration_year" rules="required|min_value:1">
                          <b-form-group
                              class="row"
                              label-cols-sm="4"
                              label-for="registration_year"
                          >
                          <template v-slot:label>
                              {{ $t('event_manage.year')}} <span class="text-danger">*</span>
                          </template>
                          <b-form-select
                              plain
                              v-model="search.registration_year"
                              :options="yearList"
                              id="registration_year"
                          >
                              <template v-slot:first>
                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                              </template>
                          </b-form-select>
                      </b-form-group>
                      </ValidationProvider>
                  </b-col>
                  <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                      <b-form-group
                          class="row"
                          label-cols-sm="4"
                          :label="$t('retailerManagement.month')"
                          label-for="registration_month"
                          >
                          <b-form-select
                          plain
                          v-model="search.registration_month"
                          :options="monthList"
                          id="registration_month"
                          >
                          <template v-slot:first>
                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                          </template>
                          </b-form-select>
                      </b-form-group>
                  </b-col>
                  <b-col xs="4" sm="4" md="4" lg="4" xl="4" >
                      <ValidationProvider name="Division" vid="pr_division_id">
                          <b-form-group
                              class="row"
                              label-cols-sm="4"
                              label-for="pr_division_id"
                              slot-scope="{ valid, errors }"
                          >
                              <template v-slot:label>
                                  {{$t('hospital_public_panel.division')}}
                              </template>
                              <b-form-select
                                  plain
                                  v-model="search.pr_division_id"
                                  :options="divisionList"
                                  id="pr_division_id"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                  :disabled="activeCenter.division_id"
                              >
                                  <template v-slot:first>
                                      <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                  </template>
                              </b-form-select>
                              <div class="invalid-feedback">
                                  {{ errors[0] }}
                              </div>
                          </b-form-group>
                      </ValidationProvider>
                  </b-col>
                  <b-col xs="4" sm="4" md="4" lg="4" xl="4">
                      <ValidationProvider name="District" vid="pr_district_id">
                          <b-form-group
                              class="row"
                              label-cols-sm="4"
                              label-for="pr_district_id"
                              slot-scope="{ valid, errors }"
                          >
                              <template v-slot:label>
                                  {{$t('hospital_public_panel.district')}}
                              </template>
                              <b-form-select
                                  plain
                                  v-model="search.pr_district_id"
                                  :options="districtList"
                                  id="pr_district_id"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                  :disabled="activeCenter.district_id"
                              >
                                  <template v-slot:first>
                                      <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                  </template>
                              </b-form-select>
                              <div class="invalid-feedback">
                                  {{ errors[0] }}
                              </div>
                          </b-form-group>
                      </ValidationProvider>
                  </b-col>
                  <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group
                        class="row"
                        label-cols-sm="4"
                        label-for="application_id"
                    >
                    <template v-slot:label>
                        {{ $t('info_manage.patient_id')}}
                    </template>
                    <b-form-input
                        id="name"
                        v-model="search.application_id"
                        @change="loadData"
                    ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
                  </b-col>
            </b-row>
          </template>
        </iq-card>
        <b-row >
          <b-col md="12" v-if="showData">
            <b-overlay>
              <iq-card>
                <template v-slot:body>
                  <b-row>
                    <b-col md="12">
                      <iq-card>
                        <template v-slot:headerTitle>
                          <h4 class="card-title">{{ $t('info_manage.patient_report_list') }}</h4>
                        </template>
                        <template v-slot:headerAction>
                          <b-button variant="primary" @click="pdfExport" class="mr-2">
                            {{  $t('globalTrans.export_pdf') }}
                          </b-button>
                            <export-excel
                              class="btn btn-success mr-2"
                              :title=headerValue
                              :fields=excelFields
                              :data=excelData
                              worksheet="Report Sheet"
                              name="patient_report.xls">
                              {{ $t('globalTrans.export_excel') }}
                          </export-excel>
                        </template>
                        <template v-slot:body>
                          <b-overlay :show="loading">
                            <div style="border: 2px solid;margin:10px;padding:10px">
                              <b-row>
                                <b-col>
                                  <b-col>
                                    <list-report-head :base-url="awarenessEventServiceBaseUrl" :uri="reportHeadingList" :org-id="3">
                                      {{ $t('info_manage.patient_report') }}
                                    </list-report-head>
                                  </b-col>
                                </b-col>
                              </b-row>
                              <b-row mt-5>
                                <b-col md="12" class="table-responsive">
                                    <b-row>
                                      <b-col xs="12" sm="12" md="6" class="text-left">
                                        <table style="color:black;">
                                            <tr v-if="search.year">
                                                <td align="right">{{ $t('event_manage.year') }}</td>
                                                <td align="center">:</td>
                                                <td align="left">{{ ($i18n.locale==='bn') ? search.year_bn : search.year }}</td>
                                            </tr>
                                            <tr v-if="search.month_name">
                                                <td align="right">{{ $t('retailerManagement.month') }}</td>
                                                <td align="center">:</td>
                                                <td align="left">{{ ($i18n.locale==='bn') ? search.month_name_bn : search.month_name }}</td>
                                            </tr>
                                        </table>
                                      </b-col>
                                      <b-col xs="12" sm="12" md="6" class="text-right">
                                        <table style="color:black; float:right;margin-right:0px;">
                                            <tr v-if="search.division_name">
                                                <td align="right">{{ $t('globalTrans.division') }}</td>
                                                <td align="center">:</td>
                                                <td align="left">{{ ($i18n.locale==='bn') ? search.division_name_bn : search.division_name }}</td>
                                            </tr>
                                            <tr v-if="search.district_name">
                                                <td align="right">{{ $t('globalTrans.district') }}</td>
                                                <td align="center">:</td>
                                                <td align="left">{{ ($i18n.locale==='bn') ? search.district_name_bn : search.district_name }}</td>
                                            </tr>
                                        </table>
                                      </b-col>
                                    </b-row>
                                  <!-- </div> -->
                                  <div class="text-black">
                                  <hr>
                                </div>
                                  <template v-if="datas.length">
                                    <b-row v-for="(item, parentIndex) in datas" :key="parentIndex">
                                      <b-col>
                                        <h4>{{ $t('globalTrans.district') }} : {{ $i18n.locale === 'en' ? item.district_name : item.district_name_bn }}</h4>
                                        <b-table-simple class="tg mt-3" bordered striped hover small caption-top responsive :emptyText="$t('globalTrans.noDataFound')">
                                          <b-thead>
                                            <b-tr>
                                              <b-th  style="text-align: center;vertical-align: middle;">{{ $t('globalTrans.sl_no') }}</b-th>
                                              <b-th  style="text-align: center;vertical-align: middle;">{{ $t('info_manage.patient_id') }}</b-th>
                                              <b-th  style="text-align: center;vertical-align: middle;">{{ $t('consultancy_therapy_center.patient_name') }}</b-th>
                                              <b-th  style="text-align: center;vertical-align: middle;">{{ $t('consultancy_therapy_center.gender') }}</b-th>
                                              <b-th  style="text-align: center;vertical-align: middle;">{{ $t('event_manage.nid_no') }}</b-th>
                                              <b-th  style="text-align: center;vertical-align: middle;">{{ $t('info_manage.dss_id') }}</b-th>
                                              <b-th  style="text-align: center;vertical-align: middle;">{{ $t('info_manage.birth_date') }}</b-th>
                                              <b-th  style="text-align: center;vertical-align: middle;">{{ $t('info_manage.center') }}</b-th>
                                              <b-th  style="text-align: center;vertical-align: middle;">{{ $t('info_manage.contact_no') }}</b-th>
                                            </b-tr>
                                          </b-thead>
                                          <b-tbody>
                                              <b-tr v-for="(info, index) in item.division_info" :key="index">
                                                <b-th class="text-center">{{ $n(index + 1) }}</b-th>
                                                <b-th class="text-center">{{ $n(info.application_id, { useGrouping: false }) }}</b-th>
                                                <b-th class="text-center">{{ ($i18n.locale === 'bn') ? info.name_bn : info.name }}</b-th>
                                                <b-th class="text-center">{{ ($i18n.locale === 'bn') ? info.gender_name_bn : info.gender_name }}</b-th>
                                                <b-th class="text-center">{{ $n(info.nid, { useGrouping: false }) }}</b-th>
                                                <b-th class="text-center">{{ $n(info.dss_id, { useGrouping: false }) }}</b-th>
                                                <b-th class="text-center">{{ info.birth_date | dateFormat }}</b-th>
                                                <b-th class="text-center">{{ ($i18n.locale === 'bn') ? info.center_name_bn : info.center_name }}</b-th>
                                                <b-th class="text-center">{{ info.mobile | mobileNumber}}</b-th>
                                              </b-tr>
                                              <b-tr>
                                                <b-td colspan="9" class="text-left">{{ $t('info_manage.district_total_patient') }}: <b>{{ $n(item.count) }}</b></b-td>
                                              </b-tr>
                                          </b-tbody>
                                        </b-table-simple>
                                      </b-col>
                                    </b-row>
                                  </template>
                                  <template v-else>
                                    <div class="text-center">
                                        {{ $t('globalTrans.noDataFound') }}
                                      </div>
                                  </template>
                                </b-col>
                              </b-row>
                            </div>
                          </b-overlay>
                        </template>
                      </iq-card>
                    </b-col>
                  </b-row>
                </template>
              </iq-card>
            </b-overlay>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import { patientReportApi, reportHeadingList } from '../../api/routes'
import flatpickr from 'flatpickr'
import ListReportHead from '@/components/custom/ListReportHeadAwareness.vue'
import ExportPdf from './export-pdf_details'
/** Excel */
import excel from 'vue-excel-export'
import Vue from 'vue'
import { helpers } from '@/mixins/helper-functions'
import { dateFormat, mobileNumber } from '@/Utils/fliter'
Vue.use(excel)

export default {
    props: ['id'],
    components: {
        ListReportHead
    },
    data () {
        return {
          search: {
            registration_year: new Date().getFullYear(),
            registration_month: 0,
            pr_division_id: 0,
            pr_district_id: 0,
            application_id: '',
            center_id: 0
          },
          awarenessEventServiceBaseUrl: awarenessEventServiceBaseUrl,
          reportHeadingList: reportHeadingList,
          datas: [],
          loading: false,
          showData: false,
          districtList: [],
          genderList: [
              {
                value: 1,
                text_en: 'Male',
                text_bn: 'পুরুষ'
              },
              {
                value: 2,
                text_en: 'Female',
                text_bn: 'মহিলা'
              }
          ],
          headerExcelDefault: {
            orgName: null,
            orgNameBn: null,
            address: null,
            address_bn: null
          },
          activeCenter: {
            value: 0,
            division_id: 0,
            district_id: 0
          }
        }
    },
    created () {
      if (this.$store.state.dataFilters.officeId) {
          const centerOfficeId = this.$store.state.dataFilters.officeId
          this.activeCenter = this.idscCenterList.find(item => item.office_id === parseInt(centerOfficeId))
          this.search = Object.assign({}, this.search, {
              pr_division_id: this.activeCenter.division_id,
              pr_district_id: this.activeCenter.district_id,
              center_id: this.activeCenter.value
          })
      }
    },
    mounted () {
        core.index()
        flatpickr('.datepicker', {})
        this.headerDataExcel()
    },
    computed: {
        yearList () {
            return helpers.getYearList()
        },
        monthList: function () {
            return this.$store.state.commonObj.monthList
        },
        divisionList () {
            return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
        },
        idscCenterList: function () {
            return this.$store.state.AwarenessEventService.commonObj.idscCenterList.filter(item => item.status === 1 && item.org_id === 3 && item.sales_center_type === 1)
        },
        headerValue: function () {
            const headerVal = []
            if (this.$i18n.locale === 'en') {
            headerVal[0] = this.$t('info_manage.govt_info')
            headerVal[1] = this.headerExcelDefault.orgName
            headerVal[2] = this.headerExcelDefault.address
            headerVal[3] = this.$t('info_manage.patient_report')
            headerVal[4] = this.getHeadParam()
            headerVal[5] = ''
            } else {
            headerVal[0] = this.$t('info_manage.govt_info')
            headerVal[1] = this.headerExcelDefault.orgNameBn
            headerVal[2] = this.headerExcelDefault.address_bn
            headerVal[3] = this.$t('info_manage.patient_report')
            headerVal[4] = this.getHeadParam()
            headerVal[5] = ''
            }
            return headerVal
        },
        excelFields: function () {
          if (this.$i18n.locale === 'bn') {
                return {
                  'জেলা ': 'district',
                  'ক্রমিক নং': 'serial',
                  'রোগীর আইডি': 'patient_id',
                  'রোগীর নাম ': 'patient_name',
                  'লিঙ্গ ': 'gender',
                  'জাতীয় পরিচয়পত্র নম্বর ': 'nid_no',
                  'জন্ম তারিখ ': 'birth_date',
                  'পিএসওএসকে ': 'center',
                  'যোগাযোগের নম্বর ': 'mobile',
                  'ডিএসএস আইডি': 'dss_id'
                }
              } else {
                return {
                  'District ': 'district',
                  'SL No': 'serial',
                  'Patient ID ': 'patient_id',
                  'Patient Name ': 'patient_name',
                  'Gender ': 'gender',
                  'Nid No ': 'nid_no',
                  'Birth Date ': 'birth_date',
                  'PSOSK Center ': 'center',
                  'Contact No ': 'mobile',
                  'Dss ID': 'dss_id'
                }
              }
        },
        excelData: function () {
          if (this.datas.length <= 0) return []
          const excelData = []
             for (let index = 0; index < this.datas.length; index++) {
              const element = this.datas[index]
              const district = this.getDistrictName(element.pr_district_id)
              excelData.push({
                    district: district,
                    serial: '',
                    patient_id: '',
                    patient_name: '',
                    gender: '',
                    nid_no: '',
                    birth_date: '',
                    center: '',
                    mobile: '',
                    dss_id: ''
                })
              // Secondary Loop
              for (let k = 0; k < element.division_info.length; k++) {
                const item = element.division_info[k]
                excelData.push({
                    district: '',
                    serial: this.$n(k + 1),
                    patient_id: this.$n(item.application_id, { useGrouping: false }),
                    patient_name: (this.currentLocale === 'en' ? item.name : item.name_bn),
                    gender: (this.$i18n.locale === 'bn') ? item.gender_name_bn : item.gender_name,
                    nid_no: this.$n(item.nid, { useGrouping: false }),
                    birth_date: dateFormat(item.birth_date),
                    center: (this.$i18n.locale === 'bn') ? item.center_name_bn : item.center_name,
                    mobile: mobileNumber(item.mobile),
                    dss_id: this.$n(item.dss_id, { useGrouping: false })
                })
              }
              /**
               * From Start to Second Last
               */
              if (index < (this.datas.length - 1)) {
                excelData.push({
                  district: district + '' + `<strong> ${this.$t('info_manage.district_total_patient')} : ${this.$n(element.count)} </strong>`,
                  serial: '',
                  patient_id: '',
                  patient_name: '',
                  gender: '',
                  nid_no: '',
                  birth_date: '',
                  center: '',
                  mobile: '',
                  dss_id: ''
                })
                excelData.push({})
              } else {
                /**
                 * Last Item for Grand Total
                 */
                excelData.push({
                    district: district + '' + `<strong> ${this.$t('info_manage.district_total_patient')} : ${this.$n(element.count)} </strong>`,
                    serial: '',
                    patient_id: '',
                    patient_name: '',
                    gender: '',
                    nid_no: '',
                    birth_date: '',
                    center: '',
                    mobile: '',
                    dss_id: ''
                })
              }
            }
            return excelData
        }
    },
    watch: {
      'search.pr_division_id': function (newVal, oldVal) {
          if (newVal) {
              this.pr_district_id = 0
              this.districtList = this.getDistrictList(newVal)
          } else {
             this.districtList = []
          }
      }
    },
    methods: {
        pdfExport () {
            const reportTitle = this.$t('info_manage.patient_report')
            ExportPdf.exportPdfDetails(awarenessEventServiceBaseUrl, '/configuration/report-heading/detail', 3, reportTitle, this.datas, this, this.search)
        },
        headerDataExcel () {
            RestApi.getData(awarenessEventServiceBaseUrl, '/configuration/report-heading/detail/3').then(response => {
              if (response.success) {
                  const orgList = this.$store.state.commonObj.organizationProfileList.find(item => item.value === 3)
                  const orgName = typeof orgList !== 'undefined' ? orgList.text_en : ''
                  const orgNameBn = typeof orgList !== 'undefined' ? orgList.text_bn : ''
                  this.headerExcelDefault.orgName = orgName
                  this.headerExcelDefault.orgNameBn = orgNameBn
                  this.headerExcelDefault.address = response.data.address
                  this.headerExcelDefault.address_bn = response.data.address_bn
              }
            })
        },
        async searchData () {
        this.getCustomSearch()
        this.loading = true
        this.showData = true
        const params = Object.assign({}, this.search)
            await RestApi.getData(awarenessEventServiceBaseUrl, patientReportApi, params).then(response => {
                if (response.success) {
                    if (response.data) {
                        this.datas = this.getRelationalData(response.data)
                    }
                } else {
                    this.datas = []
                }
            })
            this.loading = false
        },
        getRelationalData (data) {
            const listData = data.map(item => {
              const districtObj = this.$store.state.commonObj.districtList.find(division => division.value === parseInt(item.pr_district_id))
              const districtData = {
                district_name: districtObj !== undefined ? districtObj.text_en : '',
                district_name_bn: districtObj !== undefined ? districtObj.text_bn : ''
              }
              item.division_info = item.division_info.map(item1 => {
                const genderObj = this.genderList.find(gen => gen.value === parseInt(item1.gender))
                const genderData = {
                    gender_name: genderObj !== undefined ? genderObj.text_en : '',
                    gender_name_bn: genderObj !== undefined ? genderObj.text_bn : ''
                }
                const centerObj = this.$store.state.AwarenessEventService.commonObj.idscCenterList.find(center => center.value === parseInt(item1.center_id))
                const centerData = {
                    center_name: centerObj !== undefined ? centerObj.text_en : '',
                    center_name_bn: centerObj !== undefined ? centerObj.text_bn : ''
                }
                return Object.assign({}, item1, genderData, centerData)
              })
              return Object.assign({}, item, districtData)
          })
          return listData
        },
        getCustomSearch () {
          const yearObj = this.yearList.find(year => year.value === this.search.registration_year)
          if (typeof yearObj !== 'undefined') {
            this.search.year = yearObj.text
            this.search.year_bn = yearObj.text
          } else {
            this.search.year = ''
            this.search.year_bn = ''
          }
          const monthObj = this.$store.state.commonObj.monthList.find(month => month.value === parseInt(this.search.registration_month))
            if (typeof monthObj !== 'undefined') {
              this.search.month_name = monthObj.text_en
              this.search.month_name_bn = monthObj.text_bn
            } else {
              this.search.month_name = ''
              this.search.month_name_bn = ''
            }
          const divisionObj = this.$store.state.commonObj.divisionList.find(division => division.value === parseInt(this.search.pr_division_id))
            if (typeof divisionObj !== 'undefined') {
              this.search.division_name = divisionObj.text_en
              this.search.division_name_bn = divisionObj.text_bn
            } else {
              this.search.division_name = ''
              this.search.division_name_bn = ''
            }
          const districtObj = this.$store.state.commonObj.districtList.find(district => district.value === parseInt(this.search.pr_district_id))
            if (typeof districtObj !== 'undefined') {
              this.search.district_name = districtObj.text_en
              this.search.district_name_bn = districtObj.text_bn
            } else {
              this.search.district_name = ''
              this.search.district_name_bn = ''
            }
        },
        getDistrictList (DivisionId) {
            return this.$store.state.commonObj.districtList.filter(item => item.status === 0 && item.division_id === DivisionId)
        },
        getDistrictName (districtId) {
          const obj = this.$store.state.commonObj.districtList.find(item => item.status === 0 && item.value === parseInt(districtId))
          if (obj === undefined) {
            return ''
          } else {
            return this.$i18n.locale === 'bn' ? obj.text_bn : obj.text_en
          }
        },
        getHeadParam () {
          let tmpText = `${this.$t('globalTrans.division')} : ${(this.$i18n.locale === 'en' ? this.search.division_name : this.search.division_name_bn) ? (this.$i18n.locale === 'en' ? this.search.division_name : this.search.division_name_bn) : this.$t('globalTrans.all')}`
          tmpText += `, ${this.$t('globalTrans.district')} : ${(this.$i18n.locale === 'en' ? this.search.district_name : this.search.district_name_bn) ? (this.$i18n.locale === 'en' ? this.search.district_name : this.search.district_name_bn) : this.$t('globalTrans.all')}`
          tmpText += `, ${this.$t('event_manage.year')} : ${(this.$i18n.locale === 'en' ? this.search.year : this.search.year_bn) ? (this.$i18n.locale === 'en' ? this.search.year : this.search.year_bn) : this.$t('globalTrans.all')}`
          tmpText += `, ${this.$t('retailerManagement.month')} : ${(this.$i18n.locale === 'en' ? this.search.month_name : this.search.month_name_bn) ? (this.$i18n.locale === 'en' ? this.search.month_name : this.search.month_name_bn) : this.$t('globalTrans.all')}`
          return tmpText
        }
    }
}
</script>
